import { colorsPalettes } from "@similarweb/styles";
import { TrafficShareWithVisits } from "app/components/React/Table/cells";
import { TrafficShareWithTooltip } from "pro-features/components/TrafficShare/src/TrafficShareWithTooltip";
import { CHART_COLORS } from "app/constants/ChartColors";
import { FlexWithSpace, TableHeaderText, Text } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { i18nFilter } from "app/filters/i18nFilter";
import { percentageFilter } from "app/filters/ngFilters";
import {
    GroupTrafficShareContainer,
    SearchOverviewTopKeywordTableRowContainerCompare,
    TopKeywordCoreWebsiteCellContainer,
    TrafficShareContainer,
    SearchOverviewTopKeywordTrafficShareHeaderContainerCompare,
    SearchOverviewTopKeywordTrendHeaderCompareContainer,
    DomainCompareContainer,
    GroupWrapper,
} from "../SearchOverviewTraffic/StyledComponent";
import ColorStack from "app/components/colorsStack/ColorStack";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

const DomainColumnHeaderKey = "search.overview.top.keyword.compare.header.keyword";
const SearchTrafficColumnHeaderKey = "search.overview.top.keyword.compare.header.traffic.share";
const VolumeColumnHeaderKey = "search.overview.top.keyword.compare.header.total.traffic.share";
const ColumnHeaderSize = 12;
const chartMainColors = new ColorStack(CHART_COLORS.chartMainColors);

const TableRow = (row, index, routingParams, sitesColor) => {
    const { SearchTerm: searchTerm, SiteOrigins: siteOrigins } = row;
    const InnerLinkPage = "organicsearch_keywordAnalysis_overview_2";
    const innerLink = proNavigator.href(InnerLinkPage, { ...routingParams, keyword: searchTerm });
    const keywordClicked = () => {
        allTrackers.dispatchTrackEvent("Button", "click", `${searchTerm || ""}`);
    };
    const data = Object.keys(siteOrigins).map((key, value) => {
        const site = sitesColor.filter((site) => site.key === key);
        return {
            name: key,
            text: `${percentageFilter()(siteOrigins[key], 1)}%`,
            width: siteOrigins[key] * 100,
            color: colorsPalettes.carbon[0],
            backgroundColor: site[0].color,
        };
    });
    const renderLink = () => {
        if (proNavigator.current().name.match(/accountreview_/)) {
            return <span>{searchTerm}</span>;
        }

        return (
            <a
                href={innerLink}
                onClick={keywordClicked}
            >
                {searchTerm}
            </a>
        );
    };
    return (
        <SearchOverviewTopKeywordTableRowContainerCompare key={index}>
            <TopKeywordCoreWebsiteCellContainer>
                <Text>{renderLink()}</Text>
            </TopKeywordCoreWebsiteCellContainer>
            <TrafficShareContainer>
                <TrafficShareWithVisits
                    row={row}
                    value={row.TotalShare}
                />
            </TrafficShareContainer>
            <GroupWrapper>
                <GroupTrafficShareContainer>
                    <TrafficShareWithTooltip
                        data={data}
                        title={i18nFilter()("search.overview.compare.competitive.traffic.share.tooltip.title")}
                        trafficShareHeight={12}
                        minWidthToShowData={20}
                    />
                </GroupTrafficShareContainer>
            </GroupWrapper>
        </SearchOverviewTopKeywordTableRowContainerCompare>
    );
};

export const SearchOverviewTopKeywordTableComponentCompare = (props) => {
    chartMainColors.reset();
    const i18n = i18nFilter();
    const { searchOverviewTrafficData, routingParams, keys } = props;
    const splitKeys = keys.split(",");
    const sitesColor = [];
    for (let i = 0; i < splitKeys.length; i++) {
        sitesColor.push({
            key: splitKeys[i],
            color: chartMainColors.acquire(),
        });
    }
    return (
        <div>
            <FlexWithSpace>
                <DomainCompareContainer>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{i18n(DomainColumnHeaderKey)}</TableHeaderText>
                </DomainCompareContainer>
                <SearchOverviewTopKeywordTrafficShareHeaderContainerCompare>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{i18n(VolumeColumnHeaderKey)}</TableHeaderText>
                </SearchOverviewTopKeywordTrafficShareHeaderContainerCompare>
                <SearchOverviewTopKeywordTrendHeaderCompareContainer>
                    <TableHeaderText fontSize={ColumnHeaderSize}>{i18n(SearchTrafficColumnHeaderKey)}</TableHeaderText>
                </SearchOverviewTopKeywordTrendHeaderCompareContainer>
            </FlexWithSpace>
            {searchOverviewTrafficData.searchOverviewTrafficList.map((row, index) =>
                TableRow(row, index, routingParams, sitesColor),
            )}
        </div>
    );
};
